// src/ConsumerApp/Screens/Account/views/SavedItemsView.js

import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from '../../../../assets/theme/theme';

import FillBookmarkIcon from '../../../../assets/icons/FillBookmark.svg';
import ToteIcon from '../../../../assets/icons/tote.svg';
import WhitePlus from '../../../../assets/icons/WhitePlus.svg';
import WhiteMinus from '../../../../assets/icons/WhiteMinus.svg';
import ArrowLeft from '../../../../assets/icons/ArrowLeft.svg';

import { useGetSavedList, useRemoveItemFromSavedList } from '../../../api/savedList/savedList.hooks';
import {
  useGetBucketSummary,
  useAddItemToBucket,
  useUpdateBucketItemQuantity,
  useDeleteBucketItem,
} from '../../../api/products/product.hooks';

const IMAGE_BASE_URL =
  process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES || 'https://assets.brickbucket.in/';

export default function SavedItemsView() {
  const navigate = useNavigate();

  const customer = useMemo(() => {
    try {
      const stored = sessionStorage.getItem('userData') || localStorage.getItem('userData');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  }, []);

  const customerId = customer?._id || customer?.id;
  const hubId = customer?.hubId || '';

  const { data: savedItems = [], isLoading } = useGetSavedList(customerId);
  const { data: bucketSummary } = useGetBucketSummary(customerId);
  const [failedImages, setFailedImages] = useState({});

  const removeItemMutation = useRemoveItemFromSavedList();
  const addItemMutation = useAddItemToBucket();
  const updateQtyMutation = useUpdateBucketItemQuantity();
  const deleteItemMutation = useDeleteBucketItem();

  const bucketItemsMap = useMemo(() => {
    const map = new Map();
    const items = bucketSummary?.buy_now_bucket?.items || [];
    items.forEach((bItem) => {
      if (bItem?.item_id) {
        map.set(String(bItem.item_id), {
          quantity: Number(bItem.quantity) || 1,
          bucketId: bucketSummary?.buy_now_bucket?.bucket_id || bucketSummary?.buy_now_bucket?._id,
        });
      }
    });
    return map;
  }, [bucketSummary]);

  const handleRemoveSaved = (e, productId) => {
    e.stopPropagation();
    if (!customerId) return;
    removeItemMutation.mutate({ customer_id: customerId, product_id: productId });
  };

  const handleAddToCart = (e, item, isOutOfStock) => {
    e.stopPropagation();
    if (isOutOfStock) return;
    if (!customerId) {
      navigate('/consumer');
      return;
    }

    const productId = String(item.product_id || item.item_id || item._id);
    const minQty = item.quantity_limits?.min || item.buy_now?.min_qty || 1;

    addItemMutation.mutate({
      customer_id: customerId,
      hubId,
      item_id: productId,
      purchase_type: 'BUY_NOW',
      quantity: minQty,
    });
  };

  const handleUpdateQty = (e, productId, newQty, bucketId, isOutOfStock) => {
    e.stopPropagation();
    if (isOutOfStock) return;
    if (newQty <= 0) {
      deleteItemMutation.mutate({
        customer_id: customerId,
        item_id: productId,
        bucket_id: bucketId,
      });
    } else {
      updateQtyMutation.mutate({
        customer_id: customerId,
        hubId,
        item_id: productId,
        purchase_type: 'BUY_NOW',
        quantity: newQty,
      });
    }
  };

  return (
    <div>
      <style>{`
        .bb-sub-circle-back-btn {
          width: 40px;
          height: 40px;
          border-radius: 999px;
          border: 1px solid #E8E0D0;
          background-color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          flex-shrink: 0;
          padding: 0;
          margin-right: 12px;
          outline: none;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
          transition: transform 0.12s ease, background-color 0.12s ease;
          box-sizing: border-box;
        }
        .bb-sub-circle-back-btn:active {
          transform: scale(0.92);
          background-color: #F8FAFC;
        }
        .bb-sub-circle-back-btn img {
          width: 20px;
          height: 20px;
          display: block;
        }
        .bb-sub-mobile-header {
          display: none;
        }
        .bb-sub-desktop-header {
          display: flex;
        }
        .bb-saved-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
          gap: 16px;
          width: 100%;
        }
        @media (max-width: 900px) {
          .bb-sub-desktop-header {
            display: none !important;
          }
          .bb-sub-mobile-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 56px;
            padding: 0 16px;
            background-color: #FFFFFF;
            border-bottom: 1px solid #F1F5F9;
            box-sizing: border-box;
            position: sticky;
            top: 0;
            z-index: 1000;
          }
          .bb-sub-mobile-content {
            padding: 14px 16px 36px 16px !important;
          }
        }
        @media (max-width: 640px) {
          .bb-saved-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 10px !important;
          }
          .bb-saved-card-frame {
            height: 130px !important;
          }
          .bb-saved-card-body {
            padding: 10px 12px 12px 12px !important;
            gap: 3px !important;
          }
          .bb-saved-card-title {
            font-size: 13px !important;
            line-height: 17px !important;
            min-height: 34px !important;
          }
          .bb-saved-price-row {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 8px !important;
            padding-top: 6px !important;
          }
          .bb-saved-price-group {
            display: flex !important;
            align-items: baseline !important;
            gap: 6px !important;
          }
          .bb-saved-cta-btn {
            width: 100% !important;
            padding: 6px 0 !important;
            text-align: center !important;
            justify-content: center !important;
          }
          .bb-saved-stepper {
            width: 100% !important;
            height: 32px !important;
          }
        }
      `}</style>

      {/* Mobile Edge-to-Edge Bar */}
      <div className="bb-sub-mobile-header">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <button
            type="button"
            className="bb-sub-circle-back-btn"
            onClick={() => navigate('/consumer/account', { replace: true })}
            aria-label="Back to Account"
          >
            <img src={ArrowLeft} alt="Back" />
          </button>
          <h2 style={{
            fontFamily: theme.typography.headingLG.fontFamily,
            fontSize: 18,
            fontWeight: '800',
            color: theme.colors.charcoal,
            margin: 0,
          }}>
            Saved Items
          </h2>
        </div>
      </div>

      <div style={styles.container} className="bb-sub-mobile-content">
        {/* Desktop Header */}
        <div style={styles.pageHeader} className="bb-sub-desktop-header">
          <div>
            <h2 style={styles.headerTitle}>Saved Items</h2>
            <span style={styles.headerSubtitle}>
              Review your shortlisted materials and move items directly into your bucket
            </span>
          </div>
        </div>

        {isLoading ? (
          <div style={styles.loadingBox}>Loading saved materials...</div>
        ) : savedItems.length === 0 ? (
          <div style={styles.emptyBox}>
            <div style={styles.emptyIconCircle}>
              <img
                src={FillBookmarkIcon}
                alt="saved"
                style={{
                  width: 24,
                  height: 24,
                  filter:
                    'invert(16%) sepia(85%) saturate(6120%) hue-rotate(348deg) brightness(91%) contrast(106%)',
                }}
              />
            </div>
            <h4 style={styles.emptyTitle}>Your saved list is empty</h4>
            <p style={styles.emptySubtitle}>Shortlist products to order them quickly.</p>
            <button
              type="button"
              style={styles.exploreBtn}
              onClick={() => navigate('/consumer/HomeScreen')}
            >
              Explore
            </button>
          </div>
        ) : (
          <div className="bb-saved-grid">
            {savedItems.map((item, index) => {
              const productId = String(item.product_id || item.item_id || item._id);
              const name = item.product_name || item.item_name || 'Construction Material';
              const brand = item.brand || '';
              const unitPrice = Number(item.selling_price || item.price || item.unit_price || 0);
              const mrp = Number(item.mrp || 0);
              const uom = item.uom || item.uom_name || item.UOM || 'unit';

              const isOutOfStock = Boolean(
                item.out_of_stock === true ||
                item.is_out_of_stock === true ||
                item.inventory_status?.toLowerCase() === 'out_of_stock' ||
                item.stock === 0
              );

              const rawImg =
                item.product_image_url ||
                item.product_image ||
                item.product_image_stored_name ||
                item.item_image;
              const imageUrl = rawImg
                ? rawImg.startsWith('http')
                  ? rawImg
                  : `${IMAGE_BASE_URL}${rawImg}`
                : null;

              const isImgBroken = failedImages[productId];
              const bucketEntry = bucketItemsMap.get(productId);
              const inCartQty = bucketEntry && !isOutOfStock ? bucketEntry.quantity : 0;

              return (
                <div
                  key={`${productId}-${index}`}
                  style={{
                    ...styles.productCard,
                    opacity: isOutOfStock ? 0.9 : 1,
                  }}
                  onClick={() => navigate(`/consumer/productdetails`, { state: { productId } })}
                >
                  <div style={styles.imageFrame} className="bb-saved-card-frame">
                    {imageUrl && !isImgBroken ? (
                      <img
                        src={imageUrl}
                        alt={name}
                        style={{
                          ...styles.productImg,
                          filter: isOutOfStock ? 'grayscale(80%)' : 'none',
                          opacity: isOutOfStock ? 0.65 : 1,
                        }}
                        onError={() =>
                          setFailedImages((prev) => ({ ...prev, [productId]: true }))
                        }
                      />
                    ) : (
                      <div style={styles.fallbackBox}>
                        <img src={ToteIcon} alt="fallback" style={styles.toteFallback} />
                      </div>
                    )}

                    <button
                      type="button"
                      style={styles.bookmarkBtn}
                      onClick={(e) => handleRemoveSaved(e, productId)}
                      title="Remove from saved"
                    >
                      <img
                        src={FillBookmarkIcon}
                        alt="saved"
                        style={{
                          width: 15,
                          height: 15,
                          filter:
                            'invert(16%) sepia(85%) saturate(6120%) hue-rotate(348deg) brightness(91%) contrast(106%)',
                        }}
                      />
                    </button>
                  </div>

                  <div style={styles.cardBody} className="bb-saved-card-body">
                    {brand && <span style={styles.brandText}>{brand}</span>}
                    <h4 style={styles.titleText} className="bb-saved-card-title" title={name}>
                      {name}
                    </h4>
                    <span style={styles.unitText}>Per {uom}</span>

                    <div style={styles.priceActionRow} className="bb-saved-price-row">
                      <div style={styles.priceCol} className="bb-saved-price-group">
                        <span
                          style={{
                            ...styles.priceText,
                            color: isOutOfStock ? '#64748B' : theme.colors.charcoal,
                          }}
                        >
                          ₹{unitPrice.toLocaleString('en-IN')}
                        </span>
                        {!isOutOfStock && mrp > unitPrice && (
                          <span style={styles.mrpText}>₹{mrp.toLocaleString('en-IN')}</span>
                        )}
                      </div>

                      {isOutOfStock ? (
                        <div style={styles.outOfStockPill} className="bb-saved-cta-btn">
                          OUT OF STOCK
                        </div>
                      ) : inCartQty > 0 ? (
                        <div
                          style={styles.zeptoStepper}
                          className="bb-saved-stepper"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            type="button"
                            style={styles.stepperActionBtn}
                            onClick={(e) =>
                              handleUpdateQty(e, productId, inCartQty - 1, bucketEntry.bucketId, isOutOfStock)
                            }
                            aria-label="Decrease quantity"
                          >
                            <img src={WhiteMinus} alt="-" style={{ width: 15, height: 15 }} />
                          </button>
                          <span style={styles.stepperCount}>{inCartQty}</span>
                          <button
                            type="button"
                            style={styles.stepperActionBtn}
                            onClick={(e) =>
                              handleUpdateQty(e, productId, inCartQty + 1, bucketEntry.bucketId, isOutOfStock)
                            }
                            aria-label="Increase quantity"
                          >
                            <img src={WhitePlus} alt="+" style={{ width: 15, height: 15 }} />
                          </button>
                        </div>
                      ) : (
                        <button
                          type="button"
                          style={styles.addToCartBtn}
                          className="bb-saved-cta-btn"
                          onClick={(e) => handleAddToCart(e, item, isOutOfStock)}
                        >
                          ADD TO BUCKET
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    width: '100%',
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '1px solid #E2E8F0',
    paddingBottom: 16,
  },
  headerTitle: {
    ...theme.typography.headingLG,
    margin: 0,
    fontSize: 22,
    fontWeight: '800',
    color: theme.colors.charcoal,
  },
  headerSubtitle: {
    ...theme.typography.bodySM,
    fontSize: 13,
    color: theme.colors.concrete,
    marginTop: 4,
    display: 'block',
  },
  productCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    border: '1px solid #CBD5E1',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    transition: 'transform 0.15s ease, box-shadow 0.15s ease',
    boxShadow: '0 1px 3px rgba(0,0,0,0.03)',
  },
  imageFrame: {
    height: 150,
    backgroundColor: '#FAFAF9',
    borderBottom: '1px solid #F1F5F9',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
  },
  productImg: {
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
    transition: 'filter 0.2s ease, opacity 0.2s ease',
  },
  fallbackBox: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  toteFallback: {
    width: 34,
    height: 34,
    opacity: 0.35,
  },
  bookmarkBtn: {
    position: 'absolute',
    top: 8,
    right: 8,
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E8F0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    zIndex: 3,
  },
  cardBody: {
    padding: '12px 14px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: 3,
  },
  brandText: {
    fontFamily: theme.typography.bodySM.fontFamily,
    fontSize: 10,
    fontWeight: '700',
    color: theme.colors.concrete,
    textTransform: 'uppercase',
  },
  titleText: {
    ...theme.typography.headingMD,
    margin: 0,
    fontSize: 13.5,
    fontWeight: '700',
    color: theme.colors.charcoal,
    lineHeight: '18px',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    minHeight: 36,
  },
  unitText: {
    fontFamily: theme.typography.bodySM.fontFamily,
    fontSize: 11,
    color: theme.colors.concrete,
    marginBottom: 4,
  },
  priceActionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 'auto',
    paddingTop: 6,
    borderTop: '1px solid #F8FAFC',
  },
  priceCol: {
    display: 'flex',
    flexDirection: 'column',
  },
  priceText: {
    fontFamily: theme.typography.bodyMD.fontFamily,
    fontSize: 14.5,
    fontWeight: '800',
  },
  mrpText: {
    fontFamily: theme.typography.bodySM.fontFamily,
    fontSize: 10.5,
    color: theme.colors.concrete,
    textDecoration: 'line-through',
  },
  addToCartBtn: {
    backgroundColor: '#FFFFFF',
    color: theme.colors.primaryRed || '#E9001E',
    border: `1.5px solid ${theme.colors.primaryRed || '#E9001E'}`,
    borderRadius: 8,
    padding: '5px 12px',
    fontSize: 11,
    fontWeight: '800',
    cursor: 'pointer',
    outline: 'none',
    boxShadow: '0 2px 4px rgba(233,0,30,0.12)',
    letterSpacing: '0.3px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: theme.typography.bodySM.fontFamily,
  },
  outOfStockPill: {
    backgroundColor: '#F1F5F9',
    border: '1px solid #CBD5E1',
    borderRadius: 8,
    padding: '5px 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#64748B',
    fontSize: 10,
    fontWeight: '800',
    letterSpacing: '0.3px',
    pointerEvents: 'none',
    userSelect: 'none',
    fontFamily: theme.typography.bodySM.fontFamily,
  },
  zeptoStepper: {
    backgroundColor: theme.colors.primaryRed || '#E9001E',
    border: 'none',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 4px',
    width: 96,
    height: 30,
    boxSizing: 'border-box',
    boxShadow: '0 2px 6px rgba(233, 0, 30, 0.28)',
  },
  stepperActionBtn: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    width: 24,
    height: '100%',
  },
  stepperCount: {
    fontSize: 12.5,
    fontWeight: '800',
    color: '#FFFFFF',
    userSelect: 'none',
    fontFamily: theme.typography.bodyMD.fontFamily,
  },
  loadingBox: {
    padding: '50px 0',
    textAlign: 'center',
    color: theme.colors.concrete,
    fontSize: 13.5,
    fontFamily: theme.typography.bodyMD.fontFamily,
  },
  emptyBox: {
    backgroundColor: '#FFFFFF',
    borderRadius: 14,
    border: '1px dashed #CBD5E1',
    padding: '48px 24px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  emptyIconCircle: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#FFF1F2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 10,
  },
  emptyTitle: {
    ...theme.typography.headingMD,
    margin: 0,
    fontSize: 16,
    fontWeight: '700',
    color: theme.colors.charcoal,
  },
  emptySubtitle: {
    ...theme.typography.bodySM,
    margin: '6px 0 16px 0',
    fontSize: 12.5,
    color: theme.colors.concrete,
    maxWidth: 320,
    lineHeight: '18px',
  },
  exploreBtn: {
    backgroundColor: theme.colors.primaryRed || '#E9001E',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 8,
    padding: '10px 20px',
    fontSize: 13,
    fontWeight: '700',
    cursor: 'pointer',
    fontFamily: theme.typography.bodyMD.fontFamily,
  },
};